//Hari k:Breeze-7144-14-04-2025-market status -start
import { Col, Container, Row } from "react-bootstrap";
import { BzModal, BzModalBody, BzModalHeader } from "../../components";
import { handleModal } from "../../redux/actions/modals";
import { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getExchangeNameDescBySegmentId, getMktSegIdFromApiExchangeName } from "../../utils/global_functions";
import { getMarketStatus } from "../../redux/actions/orders";


const MarketStatusModal = ({ }) => {

    const dispatch = useDispatch();
    const marketStatus = useSelector(state => state.orders.marketStatus);
    const modals = useSelector(state => state?.modals?.modals)
    const objLoginSession = useSelector(state => state.auth.objLoginSession);


    const filterMarkets = useMemo(() => {
        return marketStatus.filter((each) => objLoginSession?.data?.exchanges.includes(each.exchangeSegment))
    }, [marketStatus, objLoginSession]);

    const handleClose = () => {
        dispatch(handleModal([{ 'MARKET_STATUS': false }]));
    };
    useEffect(() => {
        dispatch(getMarketStatus())
    }, [dispatch])
    return (
        <BzModal centered size='md' show={modals['MARKET_STATUS']} onHide={handleClose} className='modal-breeze-lg'>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Market Status</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <table className='table bdr'>
                    <thead>
                        <tr>
                            <th className='font-regular font-size1 table-th-color-text text-left col-md-8 bdr-rgt'>EXCHANGE</th>
                            <th className='font-regular font-size1 table-th-color-text text-center col-md-4'>STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            filterMarkets?.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td className='font-regular font-size2 table-td-color-text text-left text-uppercase col-md-4 bdr-rgt'>{getExchangeNameDescBySegmentId(getMktSegIdFromApiExchangeName(item?.exchangeSegment))}</td>
                                        <td className={`font-regular font-size2 text-center text-uppercase col-md-4`}>
                                            <div className='market-status-chips-wrap'>
                                                <div className={`${item?.sColor}`}>{item?.marketStatus}</div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </BzModalBody>
        </BzModal >

    );
}

export default memo(MarketStatusModal);
//Hari k:Breeze-7144-14-04-2025-market status - end